import { configureStore } from '@reduxjs/toolkit'
// import CartReducer from 'reducers/Cart'

export default configureStore({
  reducer: {
    // cart: CartReducer
  },
})